/**=========================================================
 * Module: flot-chart.js
 * Initializes the flot chart plugin and attaches the
 * plugin to elements according to its type
 =========================================================*/

App.controller('FlotChartController', ['$scope', '$window','$http', '$filter', '$timeout',
                                       function($scope, $window, $http, $filter,$timeout) {
  'use strict';

  /**
   * Global object to load data for charts using ajax
   * Request the chart data from the server via post
   * Expects a response in JSON format to init the plugin
   * Usage
   *   chart = new floatChart(domSelector || domElement, 'server/chart-data.php')
   *   ...
   *   chart.requestData(options);
   *
   * @param  Chart element placeholder or selector
   * @param  Url to get the data via post. Response in JSON format
   */
  $window.FlotChart = function (element, url) {
    // Properties
    this.element = $(element);
    this.url = url;

    // Public method
    this.requestData = function (option, method, callback) {
      var self = this;

      // support params (option), (option, method, callback) or (option, callback)
      callback = (method && $.isFunction(method)) ? method : callback;
      method = (method && typeof method == 'string') ? method : 'GET';

      self.option = option; // save options

      $http({
          url:      self.url,
          cache:    false,
          method:   method
      }).then(function (data) {

          $.plot( self.element, data, option );

          if(callback) callback();

      }).catch(function(){
        $.error('Bad chart request.');
      });

      return this; // chain-ability

    };

    this.setData = function (option, data, callback) {
        var self = this;

        self.option = option; // save options


        var plot = $.plot( self.element, data, option );
        var o=plot.getCanvas();
        if(option.centralNumber){



                self.element.append('<div id="'
                    +self.element[0].id
                    +'_' + 'total'
                    +'-centralNumber" class="number-in-chart '+'total'+'" style="display:'+'inline-block'+';width:'
                    +self.element[0].clientWidth
                    +'px;"><span id="number-in-chart-tooltip-container" style="position:relative;">'
                    +option.centralNumber['total']+'<span id="number-in-chart-tooltip">'+$filter('translate')('labels.TOTALSAVING')+'</span></span></div>');

            self.element.resize(function(e){
            	//var myName='#'+self.element[0].id+"-centralNumber";
            	$('#'+self.element[0].id).css('width',self.element[0].clientWidth);
            	$('#'+self.element[0].id+"_total-centralNumber").css('width',self.element[0].clientWidth);
            });
        }

        if(callback) callback();

        return this; // chain-ability

      };

    // Listen to refresh events
    this.listen = function() {
      var self = this,
          chartPanel = this.element.parents('.panel').eq(0);

      // attach custom event
      chartPanel.on('panel-refresh', function(event, panel) {
        // request data and remove spinner when done
        self.requestData(self.option, function(){
          panel.removeSpinner();
        });

      });

      return this; // chain-ability
    };

  };

  $scope.init = function(){

    		if($scope.model.contextMatch || $scope.model.fullMatch || $scope.model.fuzzyMatch || $scope.model.noMatch || $scope.model.analyzed){
	            $scope.initialized = true;

	         // Donut
	            $timeout((function () {
	                var Selector = '#chart_'+($scope.model.chartId ? $scope.model.chartId : '');
	                $(Selector).each(function() {
	                    //var source = $(this).data('source') || $.error('Donut: No source defined.');
	                    var chart = new FlotChart(this),
	                        option = {
	                            series: {
	                                pie: {
	                                    show: true,
	                                    innerRadius: 0.5 // This makes the donut shape
	                                }
	                            },
                                centralNumber: {
                                    total: '-' + $filter('display')($scope.model.normDiscount, {type:'decimal',decimals:1,def:0})
                                        + '%'
                                    }
	                        };
                        if($scope.model.contextMatch + $scope.model.fullMatch + $scope.model.fuzzyMatch + $scope.model.noMatch === 0){
                            chart.setData(option, [ { "color" : "#777777",
    	                        "data" : 100,
    	                        "label" : '----------------'
                            }]);
                        } else {
    	                    // Send Request
    	                    chart.setData(option, [ { "color" : "#32CD32",
    	                        "data" : $scope.model.contextMatch,
    	                        "label" : $filter('translate')('custom.'+$scope.model.client+'.labels.CONTEXTMATCH', {__emptyIfNotFound__:true}) || $filter('translate')('labels.CONTEXTMATCH')
    	                      },
    	                      { "color" : "#2E8B57",
    	                        "data" : $scope.model.fullMatch,
    	                        "label" : $filter('translate')('custom.'+$scope.model.client+'.labels.FULLMATCH', {__emptyIfNotFound__:true}) || $filter('translate')('labels.FULLMATCH')
    	                      },
    	                      { "color" : $scope.model.mt ? "#8FD7FF" : "#FFD700",
    	                        "data" : $scope.model.fuzzyMatch,
    	                        "label" : $filter('translate')('custom.'+$scope.model.client+'.labels.FUZZYMATCH', {__emptyIfNotFound__:true}) || $filter('translate')('labels.FUZZYMATCH')
    	                      },
    	                      { "color" : $scope.model.mt ? "#22B2FF" : "#B22222",
    	                        "data" : $scope.model.noMatch,
    	                        "label" : $filter('translate')('custom.'+$scope.model.client+'.labels.NOMATCH', {__emptyIfNotFound__:true}) || $filter('translate')('labels.NOMATCH')
    	                      }
    	                    ]);
                        }
	                });
	            }),500);

	    	} else {
	            if(!$scope.watchActivated){
	                $scope.watchActivated = true;
	                $scope.$watch('model.contextMatch', function(){
	                    if(!$scope.initialized){
	                        $scope.init();
	                    }
	                });
	            }
	        }
	    }

  $scope.init();


}]);
